import type { AddressSuggestion } from "@shared-kernel/application/ports/public/public-repository";
import type { SUPPORTED_COUNTRY } from "@shared-kernel/domain/types/supported-country";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const searchAddresses = createApiThunk<AddressSuggestion[], { query: string; sessionToken: string; country: SUPPORTED_COUNTRY }>(
  "shared/addresses/search",
  async ({ query, sessionToken, country }, { extra: { publicRepository } }) => {
    return publicRepository!.searchAddresses(query, sessionToken, country);
  },
);
